// extracted by mini-css-extract-plugin
export default {"label":"style--label--3a94d8","row":"style--row--5ddfda"};